import { render, staticRenderFns } from "./TableRoom.vue?vue&type=template&id=b987a0fc&scoped=true"
import script from "./TableRoom.vue?vue&type=script&lang=js"
export * from "./TableRoom.vue?vue&type=script&lang=js"
import style0 from "./TableRoom.vue?vue&type=style&index=0&id=b987a0fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b987a0fc",
  null
  
)

export default component.exports